import { render, staticRenderFns } from "./JciFormsList.vue?vue&type=template&id=45b9b3e9"
import script from "./JciFormsList.vue?vue&type=script&lang=js"
export * from "./JciFormsList.vue?vue&type=script&lang=js"
import style0 from "./JciFormsList.vue?vue&type=style&index=0&id=45b9b3e9&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports